import { getHtmlElement } from 'client/lib/dom'

import { DEFAULT_LOCALE } from 'shared/shared_consts'

export function getCountry() {
  const htmlElement = getHtmlElement()

  return (htmlElement && htmlElement.country) || DEFAULT_LOCALE.COUNTRY
}

export function getLanguage() {
  const htmlElement = getHtmlElement()

  const locale = htmlElement.lang

  return (locale && locale.split('_')[0]) || DEFAULT_LOCALE.LANGUAGE
}
